import { Button, Card, CardActions, CardContent, Container, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as api from '../../services/api';

const AdminDashboard = () => {
  const [userCount, setUserCount] = useState<number>(0);
  const [criteriaCount, setCriteriaCount] = useState<number>(0);
  const [transcriptionCount, setTranscriptionCount] = useState<number>(0);
  const [labelCount, setLabelCount] = useState<number>(0);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const [users, criteria, transcriptions, labels] = await Promise.all([
          api.fetchUsers(),
          api.fetchCriteria(),
          api.fetchTranscriptions(),
          api.fetchLabels(),
        ]);

        setUserCount(users.length);
        setCriteriaCount(criteria.length);
        setTranscriptionCount(transcriptions.length);
        setLabelCount(labels.length);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };

    fetchDashboardData();
  }, []);

  const adminCards = [
    {
      title: 'Users',
      count: userCount,
      description: 'Manage users',
      link: '/admin/users',
    },
    {
      title: 'Criteria',
      count: criteriaCount,
      description: 'Manage labelling criteria',
      link: '/admin/criteria',
    },
    {
      title: 'Transcriptions',
      count: transcriptionCount,
      description: 'Manage transcriptions',
      link: '/admin/transcriptions',
    },
    {
      title: 'Labels',
      count: labelCount,
      description: 'View all labels',
      link: '/admin/labels',
    },
    {
      title: 'Resolve Disagreements',
      count: '-',
      description: 'Review and resolve disagreements',
      link: '/admin/disagreements',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Admin Dashboard
      </Typography>
      <Grid container spacing={3}>
        {adminCards.map((card, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Card>
              <CardContent>
                <Typography variant="h5" component="div">
                  {card.title}
                </Typography>
                <Typography variant="h3" component="div" color="primary">
                  {card.count}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {card.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button component={Link} to={card.link} size="small">
                  Manage
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default AdminDashboard;
